import React from "react";
import styles from "./InfoModal.module.css";
import { useDispatch } from "react-redux";
import { toggleInfoModal } from "../slice/userInfoSlice";

const InfoModal = () => {
    const dispatch = useDispatch();
    const onClose = () => {
        dispatch(toggleInfoModal(false));
    }
  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <button className={styles.closeButton} onClick={onClose}>
          ✕
        </button>
        <div className={styles.infoBox}>
          <h2>Gamerz Den</h2>
          <p>PS5, XBOX, Nintendo Switch, PS VR2, Car Wheel Simulator</p>
        </div>
        <div className={styles.infoBox}>
          <h3>Contact:</h3>
          <p>Mobile No: 9360986149</p>
          <p>
            Whatsapp:{" "}
            <a
              href="https://wa.me/message/JH3M67KHLNI3E1"
              target="_blank"
              rel="noopener noreferrer"
            >
              Click here
            </a>
          </p>
        </div>
        <div className={styles.infoBox}>
          <h3>Location:</h3>
          <p>
            Velachery (Adambakkam, Ramnagar, Madipakkam) -{" "}
            <a
              href="https://maps.app.goo.gl/gBaJ9ejtQHMfU19NA"
              target="_blank"
              rel="noopener noreferrer"
            >
              View on Map
            </a>
          </p>
          <p>
            Mylapore (Santhome, MarinaBeach, Lighthouse) -{" "}
            <a
              href="https://maps.app.goo.gl/xNRNP3vJA3tcCEek9"
              target="_blank"
              rel="noopener noreferrer"
            >
              View on Map
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default InfoModal;